import { useTranslation } from 'react-i18next';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

import { Button } from 'components/Form/Button/Button';

type DiscardChangesDialogProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const DiscardChangesDialog = ({ onConfirm, onCancel }: DiscardChangesDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={onCancel} className="relative z-60">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
      <div className="fixed inset-0 z-60 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl">
          <h2 className="text-lg font-semibold text-gray-900">{t('webedi:packing_list.discard_changes.title')}</h2>
          <p className="mt-2 text-sm text-gray-500">{t('webedi:packing_list.discard_changes.description')}</p>
          <div className="mt-4 flex justify-end gap-2">
            <Button variant="secondary" onClick={onCancel} analyticsId="webedi:packing_list_discard_cancel">
              {t('common:cancel')}
            </Button>
            <Button variant="secondary-danger" onClick={onConfirm} analyticsId="webedi:packing_list_discard_confirm">
              {t('webedi:packing_list.discard_changes.confirm')}
            </Button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
